import { generateMedia } from "styled-media-query"
import theme from '../styles/theme'

const breakpoint = generateMedia(theme.breakpoints)

export default breakpoint
